import React from "react";
import classNames from "classnames";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "@design-system/Popover/Popover";
import { Separator } from "@design-system/Separator/Separator";
import { TriangleIcon } from "@icons";
import { formatDuration } from "@design-system/TimePicker/TimePicker.lib";
import { TasksEstimateTotalsData } from "./TasksEstimateTotals.lib";
import styles from "./TasksEstimateTotals.module.scss";

interface TasksEstimateTotalsProps {
    totals: TasksEstimateTotalsData;
}

export const TasksEstimateTotals: React.FC<TasksEstimateTotalsProps> = ({
    totals,
}) => {
    const { totalMinutes, byAssignee } = totals;
    const formattedTotal = formatDuration(totalMinutes);
    const hasTotalRow = byAssignee.length > 1;

    return (
        <Popover>
            <PopoverTrigger>
                <div className={styles.triggerButton}>
                    <span className="medium text-gray-700">
                        Estimate: {formattedTotal}
                    </span>
                    <TriangleIcon />
                </div>
            </PopoverTrigger>
            <PopoverContent className={styles.popoverContainer}>
                {byAssignee.map((assigneeTotal) => (
                    <div
                        key={assigneeTotal.key}
                        className={classNames(styles.line, {
                            [styles.smallPadding]: hasTotalRow,
                        })}
                    >
                        <span>{assigneeTotal.name}</span>
                        <span>{formatDuration(assigneeTotal.minutes)}</span>
                    </div>
                ))}
                {hasTotalRow && (
                    <>
                        <Separator />
                        <div className={styles.line}>
                            <span>Total</span>
                            <span>{formattedTotal}</span>
                        </div>
                    </>
                )}
            </PopoverContent>
        </Popover>
    );
};
